import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ReviewStarsProps {
  rating: number;
  size?: 'sm' | 'md' | 'lg';
  showCount?: boolean;
  count?: number;
}

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6',
};

export const ReviewStars = ({ rating, size = 'sm', showCount, count }: ReviewStarsProps) => {
  const starSize = sizeMap[size];

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = rating >= i;
        const half = !filled && rating >= i - 0.5;
        return (
          <Star
            key={i}
            className={cn(
              starSize,
              filled || half ? 'text-brand-amber fill-brand-amber' : 'text-muted'
            )}
          />
        );
      })}
      {showCount && count != null && (
        <span className="text-sm text-muted-foreground ml-1">({count})</span>
      )}
    </div>
  );
};
